import moment from 'moment';
import { useEffect, useState } from 'react';
import Loader from 'shared/common/loader';
import '../table.css';

const METALS: Record<string, string> = {
  Ag: 'Silver',
  Au: 'Gold',
  Pt: 'Platinum',
  Pd: 'Palladium',
};

const MetalBadge = ({ code }: { code: string }) => {
  const name = METALS[code] ?? code;
  const styles: Record<string, { bg: string; color: string }> = {
    Gold:      { bg: '#FEF6E0', color: '#7A5010' },
    Silver:    { bg: '#F1F2F4', color: '#374151' },
    Platinum:  { bg: '#E6EEFF', color: '#1E3A8A' },
    Palladium: { bg: '#E6F4EC', color: '#1A6637' },
  };
  const sc = styles[name] ?? { bg: '#F1F2F4', color: '#5C6470' };
  return (
    <span
      className="txn-status-badge"
      style={{ background: sc.bg, color: sc.color }}
    >
      {name}
    </span>
  );
};

const BarAllocationInvoice = ({ invoiceData }: { invoiceData: any[] }) => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (invoiceData) {
      setData(invoiceData);
      setLoading(false);
    }
  }, [invoiceData]);

  return (
    <>
      {loading && <Loader />}

      <div className="txn-wrapper">
        <div className="txn-scroll">
          <table className="txn-table">
            <colgroup>
              <col style={{ width: '14%' }} /> {/* Warehouse  */}
              <col style={{ width: '12%' }} /> {/* Bar No     */}
              <col style={{ width: '13%' }} /> {/* VSO ID     */}
              <col style={{ width: '10%' }} /> {/* Metal      */}
              <col style={{ width: '15%' }} /> {/* Order No   */}
              <col style={{ width: '20%' }} /> {/* Order Date */}
              <col style={{ width: '10%' }} /> {/* Quantity   */}
            </colgroup>

            <thead>
              <tr>
                <th>Warehouse</th>
                <th>Bar No</th>
                <th>VSO ID</th>
                <th>Metal</th>
                <th>Order No</th>
                <th>Order Date</th>
                <th className="right">Quantity</th>
              </tr>
            </thead>

            <tbody>
              {data.length === 0 && (
                <tr>
                  <td colSpan={7} className="txn-empty">
                    <div className="txn-empty-text">No data available</div>
                  </td>
                </tr>
              )}

              {data.map((metal: any, index: number) => (
                <tr
                  key={`bar-${metal.barNo ?? index}-${index}`}
                  className="txn-row-single"
                >
                  {/* Warehouse */}
                  <td>
                    <span className="txn-order-id">{metal.warehouseId}</span>
                  </td>

                  {/* Bar No */}
                  <td>
                    <span className="txn-order-id">{metal.barNo}</span>
                  </td>

                  {/* VSO ID */}
                  <td>
                    <span className="txn-order-id">{metal.vsoId}</span>
                  </td>

                  {/* Metal */}
                  <td>
                    <MetalBadge code={metal.metalCode} />
                  </td>

                  {/* Order No */}
                  <td>
                    <span className="txn-order-id">{metal.ebOrderRef}</span>
                  </td>

                  {/* Order Date */}
                  <td>
                    <div className="txn-date">
                      {moment(metal.orderDate).format('DD MMM YYYY')}
                    </div>
                    <div className="txn-time">
                      {moment(metal.orderDate).format('hh:mm:ss A')}
                    </div>
                  </td>

                  {/* Quantity */}
                  <td className="right">
                    <span className="txn-amount-parent">{metal.quantity} g</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default BarAllocationInvoice;